import { render } from "./LogsList.vue?vue&type=template&id=f0503c60&scoped=true"
import script from "./LogsList.vue?vue&type=script&lang=js"
export * from "./LogsList.vue?vue&type=script&lang=js"

import "./LogsList.vue?vue&type=style&index=0&id=f0503c60&scoped=true&lang=css"

import exportComponent from "D:\\dev\\mdm-crtwww-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0503c60"]])

export default __exports__